import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight, Clock } from "lucide-react";
import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";
import { PageHero, Section, PrimaryButton } from "@/components/ui-helpers";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { ChevronDown } from "lucide-react";
import { api } from "@/lib/api";

function MenuCard({ m }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="ascendia-card card-accent-top p-6">
      <div className="flex items-baseline justify-between gap-3">
        <h3 className="font-display text-xl font-semibold text-white u-tracking-tight">{m.name}</h3>
      </div>
      <p className="mt-2 text-sm text-secondary u-body">{m.ideal}</p>
      <div className="mt-3 flex items-center gap-2 text-xs text-gold-soft"><Clock className="h-4 w-4" /> {m.time}</div>
      <Collapsible open={open} onOpenChange={setOpen} className="mt-4">
        <CollapsibleTrigger className="flex items-center gap-1 text-sm text-white/80 hover:text-white">
          {open ? "Hide" : "What's included"} <ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} />
        </CollapsibleTrigger>
        <CollapsibleContent className="mt-3">
          <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-2">
            {m.includes.map((it) => <li key={it} className="flex items-center gap-2 text-sm text-secondary"><Check className="h-4 w-4 text-gold" /> {it}</li>)}
          </ul>
        </CollapsibleContent>
      </Collapsible>
      <Link to={`/contact?service=${encodeURIComponent(m.name)}`} className="mt-5 inline-flex items-center gap-1 text-sm text-gold-soft hover:text-gold">Request This Detail <ArrowRight className="h-4 w-4" /></Link>
    </div>
  );
}

export default function DetailingMenu() {
  const [menu, setMenu] = useState([]);
  useEffect(() => { api.get("/detailing-menu").then(({ data }) => setMenu(data)).catch(() => {}); }, []);
  return (
    <>
      <SEO title="Ascendia Detail Menu" description="Signature detailing services: bathroom, kitchen, window, appliance, balcony and full-home detailing." />
      <PageHero kicker="Ascendia Detail Menu" title="Focused, meticulous detailing services" subtitle="Every surface. Every corner. Every detail. Choose a signature detail or the full-home treatment." image="https://images.unsplash.com/photo-1763978485095-1cd13f4d3cb3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600">
        <PrimaryButton to="/contact">Request a Quote <ArrowRight className="h-4 w-4" /></PrimaryButton>
      </PageHero>
      <Section>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {menu.map((m, i) => <Reveal key={m.id} delay={(i % 3) * 0.06}><MenuCard m={m} /></Reveal>)}
        </div>
      </Section>
    </>
  );
}
